export default "__VITE_ASSET__5bca626b__"